var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-page-table',{attrs:{"apiName":_vm.apiName,"nameRole":_vm.nameRoleEntity,"titleTable":_vm.$t('Агентства'),"paramsGetData":_vm.paramsGetData,"fieldLand":_vm.fieldLang,"keyTable":'id',"deleteParams":_vm.deleteParams,"apiDeleteName":_vm.apiDeleteName,"forceIsCreate":false,"forceIsEdit":false,"forceDelete":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }